import { render, staticRenderFns } from "./KButton.vue?vue&type=template&id=48bd6156&scoped=true&lang=html&"
var script = {}
import style0 from "./KButton.vue?vue&type=style&index=0&id=48bd6156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd6156",
  null
  
)

export default component.exports